// dependencies
import { GenerateProcess } from "redux-process";

// ui
import ui from "./ui";

// actions
import { updateUI } from "Actions/ui";

// selectors
import { getUI, getPageName } from "Selectors/ui";
import { getRecentUsersLimit, getSkipCount } from "./selectors";

export const changeUI = (keyPath, value) => (dispatch, getState) => {
	const state = getState();
	const pageName = getPageName(state);
	const newKeyPath = [pageName].concat(keyPath);

	dispatch(updateUI(newKeyPath, value));
};

/**
 * Fetch (or refetch) the data
 */
export const fetchPageData = () => async (dispatch, getState) => {
	// request
	const state = getState();
	const skip = getSkipCount(state);
	const limit = getRecentUsersLimit(state);

	// request
	const request = await dispatch(GenerateProcess("GetRecentUsers", { limit, skip }));

	let currentUI = getUI(getState());

	currentUI = currentUI.withMutations((mutable) => {
		mutable.set("recentUsersCount", request.response.get("count"));
		mutable.set("recentUsers", request.response.get("recentUsers"));
	});

	dispatch(changeUI([], currentUI));
};

/**
 * Changes the page number and then fetches the data.
 *
 * @param {number} page - next page number
 */
export const changePage = (page) => async (dispatch) => {
	dispatch(changeUI(["currentPage"], page));
	await dispatch(fetchPageData());

	window.scrollTo(0, 0);
};

/**
 * Initialize page.
 */
export const init = () => (dispatch) => {
	// set the initial UI
	const initialUI = ui;
	dispatch(changeUI([], initialUI));

	// fetch page data
	dispatch(fetchPageData());
};
